import type { BatMetadataConfigEntry } from './common/types';
import { coreFields, genericUnitField } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import {
  currencyField,
  currencyQuantityField,
} from './common/expenditureFields';

export const lodgingMetadata = {
  displayName: msg({
    message: 'Lodging',
    context: 'Activity data schema name for lodging',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    currency: currencyField,
    currency_quantity: currencyQuantityField,
    lodging_kind: {
      displayName: msg({
        message: 'Lodging kind',
        context: 'The type of lodging establishment.',
      }),
    },
    lodging_unit_quantity: {
      displayName: msg({
        message: 'Room count',
        context: 'The number of lodging units rented for the stay.',
      }),
      externalDescription: msg({
        message: 'The number of lodging units rented for the stay.',
        context: 'Room count',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Nights',
        context: 'The number of nights stayed for a single lodging unit.',
      }),
      externalDescription: msg({
        message: 'The number of nights stayed per room.',
        context: 'Nights',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
